import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DfModule, DfSelectModule } from '@design-factory/design-factory';
import { NgbCompatModule } from '@uxdf/direct-shared-lib';
import { NgSelectModule } from '@ng-select/ng-select';
import { DoughnutChartModule } from '../../../directives/doughnutChart.module';
import { BookingsAndRevenuesComponent } from './bookings-and-revenues/bookings-and-revenues.component';
import { DashboardAVCComponent } from './dashboard-avc.component';
import { KPIFilterComponent } from './kpi-filter/kpi-filter.component';
import { KpiSummaryComponent } from './kpi-summary/kpi-summary.component';
import { LargeNumeralShortenerPipe } from './kpi-summary/large-numeral-shortener.pipe';
import { TopDestinationsComponent } from './top-destinations/top-destinations.component';
import { StoreModule } from '@ngrx/store';
import { reducer } from './redux/reducers/reducers-dashboard';
import { EffectsModule } from '@ngrx/effects';
import { EffectsAvcDashboard } from './redux/effects/effects-dashboard';
import { OfficeIdTransform } from './utils/pipes/office-id-transform.pipe';
@NgModule({
  declarations: [
    DashboardAVCComponent,
    KPIFilterComponent,
    KpiSummaryComponent,
    LargeNumeralShortenerPipe,
    BookingsAndRevenuesComponent,
    TopDestinationsComponent,
    OfficeIdTransform
  ],
  exports: [
    DashboardAVCComponent,
    KPIFilterComponent
  ],
  imports: [
    StoreModule.forFeature('avc_dashboard', reducer),
    EffectsModule.forFeature([EffectsAvcDashboard]),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    DfSelectModule,
    NgbCompatModule,
    DfModule,
    DoughnutChartModule
  ]
})
export class DashboardAVCModule { }
